import { TFunctionResult } from 'i18next';

export const lineBreak = (value: string | number | TFunctionResult) => (
  <div style={{ whiteSpace: 'normal' }} data-tag="allowRowEvents">
    {value}
  </div>
);
